import {Routes,Route} from 'react-router-dom';
import React, { useEffect } from 'react';
import logo from './logo.svg';
import Main from './components/Main'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
const theme = createTheme();

function App() {
    useEffect(() => {
        document.body.style.backgroundColor = '#e9f6f7';
    }, []);

  return (
     <div className="container-fluid">
      <ThemeProvider theme={theme}>
      <CssBaseline />
      <Main />
    </ThemeProvider>

     </div>
  );
}

export default App;
